import type { PropsWithChildren } from 'react';
import { IFdrSrlControlState } from 'fdr/components/candidate/fdr-search/types/union-state-form.types';

export enum EThemeFormPageType {
  THEME = 'THEME',
  THEME_OVERVIEW = 'THEME_OVERVIEW',
}

export interface IFdrThemeProps extends PropsWithChildren<{}> {
  id?: string;
  handleCancel?: () => void;
  postSubmit?: (state: IFdrSrlControlState) => void;
  pageType: EThemeFormPageType;
}
